/** Tablet floor / phone band — matches P1 Smart Planning product gates. */
export const MOBILE_MAX_WIDTH_MEDIA_QUERY = '(max-width: 767px)';

/** Smart Planning wizard compact nav (sidebar → top steps). Keep SCSS `@media` breakpoints in sync. */
export const COMPACT_NAV_MAX_WIDTH_PX = 1203;
export const COMPACT_NAV_MAX_WIDTH_MEDIA_QUERY = `(max-width: ${COMPACT_NAV_MAX_WIDTH_PX}px)`;

/** Health category detail bottom sheet (inline detail → modal) at tablet/small desktop widths. */
export const HEALTH_CATEGORY_SHEET_MAX_WIDTH_PX = 1024;
export const HEALTH_CATEGORY_SHEET_MAX_WIDTH_MEDIA_QUERY = `(max-width: ${HEALTH_CATEGORY_SHEET_MAX_WIDTH_PX}px)`;

/** A real pointing device, so not a phone or tablet. Used to hold back autofocus that would open a soft keyboard. */
export const FINE_POINTER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

export function createMobileMaxWidthMediaQuery(): MediaQueryList | null {
    return typeof matchMedia !== 'undefined' ? matchMedia(MOBILE_MAX_WIDTH_MEDIA_QUERY) : null;
}

export function createCompactNavMaxWidthMediaQuery(): MediaQueryList | null {
    return typeof matchMedia !== 'undefined' ? matchMedia(COMPACT_NAV_MAX_WIDTH_MEDIA_QUERY) : null;
}

export function createHealthCategorySheetMaxWidthMediaQuery(): MediaQueryList | null {
    return typeof matchMedia !== 'undefined' ? matchMedia(HEALTH_CATEGORY_SHEET_MAX_WIDTH_MEDIA_QUERY) : null;
}

export function createFinePointerMediaQuery(): MediaQueryList | null {
    return typeof matchMedia !== 'undefined' ? matchMedia(FINE_POINTER_MEDIA_QUERY) : null;
}

export function matchesMobileMaxWidthViewport(
    media: Pick<MediaQueryList, 'matches'> | null | undefined
): boolean {
    return media?.matches === true;
}

export function matchesHealthCategorySheetViewport(
    media: Pick<MediaQueryList, 'matches'> | null | undefined
): boolean {
    return media?.matches === true;
}
